<template>
  <div class="container tips-container" >
    <p class="content-title" v-if="pic_desc.title">{{pic_desc.title}}</p>
    <template v-if="pic_desc.content && Array.isArray(pic_desc.content)">
      <p :class="['content-p', {'is-in-app': inApp}]" v-for="(t,idx) in pic_desc.content" :key="idx" v-html="t">{{t}}</p>
    </template>
  </div>
</template>
<script>
import { ends } from "../../tools/constant";
export default {
  props: ["formItem", "idx", "omegaItem"],
  computed: {
    inApp() {
      return ends.inApp;
    },
    pic_desc() {
      return this.formItem.pic_desc || {}
    }
  },
  mounted(){
    // console.log(this.formItem)
    const TipsContainer = document.querySelector('.tips-container');
    TipsContainer.addEventListener('click', (e) => {
      // console.log(e.target.nodeName)
      if(e.target.nodeName.toUpperCase() == "A"){
        try {
          Omega.trackEvent("ibt_gd_upload_como_link_ck", "", {
            ...this.omegaItem,
            link: e.target.href
          });
        } catch (error) { }
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.tips-container {
  padding: 0 0.32rem;
  margin-top: 0.8rem;
  p{
    font-size: .28rem;
    color: #999999;
    font-weight: 400;
  }
  .is-in-app {
    ::v-deep .down_load_tip {
      display: none;
    }
  }
}
</style>

